export const config = {
  authority: process.env.REACT_APP_SMARTPRINT_AUTHORITY,
  client_id: process.env.REACT_APP_SMARTPRINT_CLIENTID,
  redirect_uri: process.env.REACT_APP_SMARTPRINT_REDIRECTURI,
  silent_redirect_uri: process.env.REACT_APP_SMARTPRINT_SILENT_REDIRECTURI,
  scope: process.env.REACT_APP_SMARTPRINT_SCOPE,
  response_type: process.env.REACT_APP_RESPONSE_TYPE,
  post_logout_redirect_uri:
    process.env.REACT_APP_SMARTPRINT_POSTLOGOUTREDIRECTURI,
  filterProtocolClaims: true,
  loadUserInfo: true,
  includeIdTokenInSilentRenew: true,
  automaticSilentRenew: true,
  monitorSession: true
};